const inputNamePrefixer = (prefix: string) => (name: string) => "lobcv_answers_" + prefix + name;

export {inputNamePrefixer}
